function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { DrmType } from '../core/player/playout-data';
import { AudioCodec, AudioFormat } from '../core/player/audio-format';
import { MIN_4K_HDCP_VERSION, MIN_HD_HDCP_VERSION } from '../core/player/video-format';
import { sdkLogger } from '../logger';
import { Resolutions } from './resolution';
import { AudioCodecType, DrmKind, StatusPolicies, UhdHdrCodec } from './probe-utils.enums';
var audioCodecMimeType = 'audio/mp4';
var _obj;
// 4k + HDR Codecs used by OVP
export var UhdHdrCodecs = (_obj = {}, _define_property(_obj, UhdHdrCodec.Uhd, {
    codec: 'video/mp4;codecs="hvc1.1.6.L150.90"',
    // H.265 Main profile, level 5 (up to 4k). 8 bits per color per pixel (SDR)
    mimeType: 'video/mp4',
    rawCodecs: '"hvc1.1.6.L150.90"',
    rawCodecsUnquoted: 'hvc1.1.6.L150.90'
}), _define_property(_obj, UhdHdrCodec.HdrHlg, {
    codec: 'video/mp4;codecs="hvc1.1.6.L150.90"',
    mimeType: 'video/mp4',
    rawCodecs: '"hvc1.1.6.L150.90"',
    hdrMetadataType: undefined,
    colorGamut: 'rec2020',
    transferFunction: 'hlg',
    rawCodecsUnquoted: 'hvc1.1.6.L150.90'
}), _define_property(_obj, UhdHdrCodec.Hdr10, {
    codec: 'video/mp4;codecs="hvc1.2.4.L150.90"',
    // H.265 Main 10 profile, level 5 (up to 4k). Up to 10 bits per color per pixel; capable of containing HDR content but is not required to
    hdrTransferFunc: 'eotf="smpte2084"',
    // electro-optical transfer function that describes HDR color space (for use with 10-bit profiles only)
    mimeType: 'video/mp4',
    rawCodecs: '"hvc1.2.4.L150.90"',
    hdrMetadataType: 'smpteSt2086',
    colorGamut: 'rec2020',
    transferFunction: 'pq',
    rawCodecsUnquoted: 'hvc1.2.4.L150.90'
}), _define_property(_obj, UhdHdrCodec.Hdr10Plus, {
    codec: 'video/mp4;codecs="hvc1.2.4.L150.90"',
    // H.265 Main 10 profile, level 5 (up to 4k). Up to 10 bits per color per pixel; capable of containing HDR content but is not required to
    hdrTransferFunc: 'eotf="smpte2084"',
    // electro-optical transfer function that describes HDR color space (for use with 10-bit profiles only)
    mimeType: 'video/mp4',
    rawCodecs: '"hvc1.2.4.L150.90"',
    hdrMetadataType: 'smpteSt2094-10',
    colorGamut: 'rec2020',
    transferFunction: 'pq',
    rawCodecsUnquoted: 'hvc1.2.4.L150.90'
}), _define_property(_obj, UhdHdrCodec.DolbyVision, {
    codec: 'video/mp4;codecs="dvh1.05.06"',
    mimeType: 'video/mp4',
    rawCodecs: '"dvh1.05.06"',
    hdrMetadataType: 'smpteSt2094-10',
    colorGamut: 'rec2020',
    transferFunction: 'pq',
    rawCodecsUnquoted: 'dvh1.05.06'
}), _obj);
var _obj1;
export var AudioCodecs = (_obj1 = {}, _define_property(_obj1, AudioCodecType.MPEG_4_LC, getAudioCodecSpecs(AudioCodec.MP4A2)), _define_property(_obj1, AudioCodecType.MPEG_4_SBR, getAudioCodecSpecs(AudioCodec.MP4A5)), _define_property(_obj1, AudioCodecType.DolbyDigital, getAudioCodecSpecs(AudioCodec.AC3)), // Dolby Digital. Max 5.1 channels
_define_property(_obj1, AudioCodecType.DolbyDigitalPlus, getAudioCodecSpecs(AudioCodec.EC3)), _obj1);
var _obj2;
// Dolby Digital Plus. Max 7.1 channels. Can carry Dolby Atmos if device also supports spatial rendering
// DRM levels for UHD codecs
export var drmUHDlevel = (_obj2 = {}, _define_property(_obj2, DrmKind.Widevine, 'HW_SECURE_ALL'), _define_property(_obj2, DrmKind.PlayReady, '3000'), _define_property(_obj2, DrmKind.FairPlay, undefined), _obj2);
var uhdStreamSpecs = {
    bitrate: 12500000,
    width: Resolutions.UHD.minWidth,
    height: Resolutions.UHD.minHeight,
    framerate: 30
};
function getAudioCodecSpecs(audioCodec) {
    return {
        codec: "".concat(audioCodecMimeType, ';codecs="').concat(audioCodec, '"'),
        mimeType: audioCodecMimeType,
        rawCodecs: '"'.concat(audioCodec, '"'),
        rawCodecsUnquoted: audioCodec
    };
}
function isCodecSupported(codec) {
    if (codec && 'MediaSource' in self && self.MediaSource.isTypeSupported) {
        return self.MediaSource.isTypeSupported(codec);
    }
    return false;
}
export function isVideoCodecSupported(codec, eotf) {
    var codecString = UhdHdrCodecs[codec].codec;
    if (codecString && eotf && UhdHdrCodecs[codec].hdrTransferFunc) {
        codecString += ";".concat(UhdHdrCodecs[codec].hdrTransferFunc);
    }
    return isCodecSupported(codecString);
}
export function isAudioCodecSupported(codec) {
    var _AudioCodecs_codec;
    return isCodecSupported((_AudioCodecs_codec = AudioCodecs[codec]) === null || _AudioCodecs_codec === void 0 ? void 0 : _AudioCodecs_codec.codec);
}
export function probeSupportedAudioCodecs() {
    var codecs = [];
    if (isCodecSupported(AudioCodecs.DolbyDigitalPlus.codec)) {
        codecs.push(AudioCodecs.DolbyDigitalPlus.rawCodecsUnquoted);
    } else if (isCodecSupported(AudioCodecs.MPEG_4_LC.codec)) {
        codecs.push(AudioCodecs.MPEG_4_LC.rawCodecsUnquoted);
    }
    // Should only be used by Showmax
    if (isCodecSupported(AudioCodecs.MPEG_4_SBR.codec)) {
        codecs.push(AudioCodecs.MPEG_4_SBR.rawCodecsUnquoted);
    }
    return codecs;
}
export function getMediaSourceSupportedAudioFormats() {
    var audioFormats = [
        AudioFormat.STEREO
    ];
    if (isAudioCodecSupported(AudioCodecType.DolbyDigitalPlus)) {
        audioFormats.push(AudioFormat.SURROUND_5_1, AudioFormat.SURROUND_7_1, AudioFormat.ATMOS);
    } else if (isAudioCodecSupported(AudioCodecType.DolbyDigital)) {
        audioFormats.push(AudioFormat.SURROUND_5_1);
    }
    return audioFormats;
}
// Probe HDR10 support for codec via navigator.mediaCapabilities with hdrMetadataType
export function probeHdrSupportByMediaCapabilities() {
    return _probeHdrSupportByMediaCapabilities.apply(this, arguments);
}
function _probeHdrSupportByMediaCapabilities() {
    _probeHdrSupportByMediaCapabilities = _async_to_generator(function() {
        var codecType, logger, config, // eslint-disable-next-line @typescript-eslint/no-explicit-any -- The types for decodingInfo don't match what we are passing in, although it seems to work fine.
        decodingSupport, e;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    codecType = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : UhdHdrCodec.Hdr10;
                    logger = sdkLogger.withContext('PRB');
                    if (!(navigator && 'mediaCapabilities' in navigator && 'decodingInfo' in navigator.mediaCapabilities)) return [
                        3,
                        5
                    ];
                    config = {
                        type: 'media-source',
                        video: {
                            contentType: UhdHdrCodecs[codecType].codec,
                            framerate: uhdStreamSpecs.framerate,
                            bitrate: uhdStreamSpecs.bitrate,
                            height: uhdStreamSpecs.height,
                            width: uhdStreamSpecs.width,
                            hdrMetadataType: UhdHdrCodecs[codecType].hdrMetadataType,
                            colorGamut: UhdHdrCodecs[codecType].colorGamut,
                            transferFunction: UhdHdrCodecs[codecType].transferFunction
                        }
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        navigator.mediaCapabilities.decodingInfo(config)
                    ];
                case 2:
                    decodingSupport = _state.sent();
                    return [
                        2,
                        decodingSupport.supported
                    ];
                case 3:
                    e = _state.sent();
                    logger.warn("mediaCapabilities.decodingInfo() failed: ".concat(e));
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    return [
                        2,
                        false
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return _probeHdrSupportByMediaCapabilities.apply(this, arguments);
}
/**
 * @internal Probes device for UHD-required HDCP 2.2 support of given codec
 * @param codec: codec to check
 * @param drm: flavor of DRM (required for Media Keys API)
 * @returns codecDrmProbeReturn object containing flag for successful completion of getStatusForPolicy() call and resulting HDCP 2.2 support
 */ export function getHDCPstatusForUHD(codec, drm) {
    return _getHDCPstatusForUHD.apply(this, arguments);
}
function _getHDCPstatusForUHD() {
    _getHDCPstatusForUHD = _async_to_generator(function(codec, drm) {
        var isSupported, callSuccessful, codecString, logger, config, robustnessStr, mediaKeySystemAccess, mediaKeys, status, error, error1;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    isSupported = false;
                    callSuccessful = false;
                    codecString = UhdHdrCodecs[codec].codec;
                    logger = sdkLogger.withContext('PRB');
                    config = [
                        {
                            initDataTypes: [
                                'cenc'
                            ],
                            videoCapabilities: [
                                {
                                    contentType: codecString,
                                    robustness: drmUHDlevel[drm],
                                    width: Resolutions.UHD.minWidth,
                                    height: Resolutions.UHD.minHeight
                                }
                            ]
                        }
                    ];
                    robustnessStr = config[0].videoCapabilities[0].robustness ? " w/ ".concat(config[0].videoCapabilities[0].robustness) : "";
                    if (!('requestMediaKeySystemAccess' in navigator)) return [
                        3,
                        10
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    return [
                        4,
                        navigator.requestMediaKeySystemAccess(drm, config)
                    ];
                case 2:
                    mediaKeySystemAccess = _state.sent();
                    return [
                        4,
                        mediaKeySystemAccess.createMediaKeys()
                    ];
                case 3:
                    mediaKeys = _state.sent();
                    if (!!('getStatusForPolicy' in mediaKeys)) return [
                        3,
                        4
                    ];
                    logger.warn("HDCP Policy Check API is not available: getStatusForPolicy does not exist.");
                    return [
                        3,
                        7
                    ];
                case 4:
                    _state.trys.push([
                        4,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4,
                        mediaKeys.getStatusForPolicy({
                            minHdcpVersion: MIN_4K_HDCP_VERSION
                        })
                    ];
                case 5:
                    status = _state.sent();
                    if (status !== 'usable') {
                        callSuccessful = true;
                        logger.info("No HDCP support for ".concat(MIN_4K_HDCP_VERSION).concat(robustnessStr));
                    } else {
                        callSuccessful = true;
                        isSupported = true;
                        logger.info("HDCP is supported for ".concat(MIN_4K_HDCP_VERSION).concat(robustnessStr));
                    }
                    return [
                        3,
                        7
                    ];
                case 6:
                    error = _state.sent();
                    logger.warn("HDCP support cannot be determined for ".concat(MIN_4K_HDCP_VERSION).concat(robustnessStr, ": ").concat(error));
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        3,
                        9
                    ];
                case 8:
                    error1 = _state.sent();
                    logger.warn("Error getting mediaKeySystemAccess/mediaKeys for ".concat(codecString, " : ").concat(error1));
                    return [
                        3,
                        9
                    ];
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    logger.warn("navigator.requestMediaKeySystemAccess does not exist");
                    _state.label = 11;
                case 11:
                    return [
                        2,
                        {
                            callSuccessful: callSuccessful,
                            isSupported: isSupported
                        }
                    ];
            }
        });
    });
    return _getHDCPstatusForUHD.apply(this, arguments);
}
var getMediaKeysHelper = function(keySystems, config) {
    var promises = keySystems.map(function(keySystem) {
        var _navigator;
        return (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.requestMediaKeySystemAccess(keySystem, config).then(function(access) {
            return access === null || access === void 0 ? void 0 : access.createMediaKeys();
        }).catch(function() {
            return false;
        });
    });
    return Promise.all(promises);
};
var _obj3;
var drmToHDCPVersion = (_obj3 = {}, _define_property(_obj3, DrmType.Widevine, {
    keySystems: [
        'com.widevine.alpha'
    ],
    config: [
        {
            videoCapabilities: [
                {
                    contentType: 'video/mp4; codecs="avc1.42E01E"',
                    robustness: 'SW_SECURE_DECODE'
                }
            ]
        }
    ],
    // Widevine L3
    getMediaKeys: function getMediaKeys() {
        return getMediaKeysHelper(this.keySystems, this.config);
    }
}), _define_property(_obj3, DrmType.PlayReady, {
    keySystems: [
        'com.microsoft.playready'
    ],
    config: [
        {
            videoCapabilities: [
                {
                    contentType: 'video/mp4; codecs="avc1.42E01E"'
                }
            ]
        }
    ],
    getMediaKeys: function getMediaKeys() {
        return getMediaKeysHelper(this.keySystems, this.config);
    }
}), _define_property(_obj3, DrmType.Fairplay, {
    keySystems: [],
    getMediaKeys: /*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            return [
                2,
                [
                    true
                ]
            ];
        });
    })
}), _define_property(_obj3, DrmType.Marlin, {
    keySystems: [],
    getMediaKeys: /*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            return [
                2,
                [
                    true
                ]
            ];
        });
    })
}), _obj3);
var isMediaKeyUsable = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(mediaKey) {
        var statusForPolicy;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!mediaKey) {
                        return [
                            2,
                            false
                        ];
                    }
                    if (mediaKey === true) {
                        return [
                            2,
                            true
                        ];
                    }
                    return [
                        4,
                        mediaKey.getStatusForPolicy({
                            minHdcpVersion: MIN_HD_HDCP_VERSION
                        })
                    ];
                case 1:
                    statusForPolicy = _state.sent();
                    return [
                        2,
                        statusForPolicy === StatusPolicies.USABLE
                    ];
            }
        });
    });
    return function isMediaKeyUsable(mediaKey) {
        return _ref.apply(this, arguments);
    };
}();
var probeHDCPStatusForHD = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(mediaKeys) {
        var logger, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, mediaKey, err, err1;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    logger = sdkLogger.withContext('PRB');
                    if (!mediaKeys) {
                        return [
                            2,
                            false
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        ,
                        11
                    ]);
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _iterator = mediaKeys[Symbol.iterator]();
                    _state.label = 3;
                case 3:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        6
                    ];
                    mediaKey = _step.value;
                    return [
                        4,
                        isMediaKeyUsable(mediaKey)
                    ];
                case 4:
                    if (_state.sent()) {
                        return [
                            2,
                            true
                        ];
                    }
                    _state.label = 5;
                case 5:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        3
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    err1 = _state.sent();
                    logger.warn("mediaKey.getStatusForPolicy() failed: ".concat(err1));
                    return [
                        3,
                        11
                    ];
                case 11:
                    return [
                        2,
                        false
                    ];
            }
        });
    });
    return function probeHDCPStatusForHD(mediaKeys) {
        return _ref.apply(this, arguments);
    };
}();
export function getHDCPStatusForHD(drmType) {
    return _getHDCPStatusForHD.apply(this, arguments);
}
function _getHDCPStatusForHD() {
    _getHDCPStatusForHD = _async_to_generator(function(drmType) {
        var drmHDCPVersion, mediaKeys;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    // If there is no DRM type then it is by default compliant and HD should be enabled
                    if (drmType === undefined) {
                        return [
                            2,
                            true
                        ];
                    }
                    drmHDCPVersion = drmToHDCPVersion[drmType];
                    return [
                        4,
                        drmHDCPVersion.getMediaKeys()
                    ];
                case 1:
                    mediaKeys = _state.sent();
                    return [
                        2,
                        probeHDCPStatusForHD(mediaKeys)
                    ];
            }
        });
    });
    return _getHDCPStatusForHD.apply(this, arguments);
}
export function areCodecsCompatible(codec1, codec2) {
    return getCodecBase(codec1) === getCodecBase(codec2);
}
function getCodecBase(codec) {
    return codec ? codec.split('.')[0] : '';
}

//# sourceMappingURL=probe-utils.js.map